export enum SearchActionType {
  FETCH_SEARCH_REQUEST = 'search/FETCH_SEARCH_REQUEST',
  FETCH_SEARCH_SUCCESS = 'search/FETCH_SEARCH_SUCCESS',
  FETCH_SEARCH_FAILURE = 'search/FETCH_SEARCH_FAILURE',
}
